import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/api/client";
import type { ClinOpsView } from "@/api/types";

export function useClinOpsView(siteId: string | undefined, daCode: string | undefined) {
  return useQuery<ClinOpsView>({
    queryKey: ["sites", siteId, "clinops", daCode],
    queryFn: () =>
      apiRequest<ClinOpsView>(`/api/sites/${siteId}/clinops/${daCode}`),
    enabled: Boolean(siteId && daCode),
    staleTime: 30_000,
  });
}
